import { supabase } from '../../lib/supabase';
import type { Release } from '../../types/database';

export async function fetchReleases(bandId: string): Promise<Release[]> {
  try {
    const { data, error } = await supabase
      .from('releases')
      .select('*')
      .eq('band_id', bandId)
      .order('order', { ascending: true })
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error('Error fetching releases:', error);
    throw error;
  }
}

export async function updateReleaseOrder(releases: Release[]): Promise<void> {
  try {
    // Update each release individually since we don't have the RPC function yet
    const updatePromises = releases.map((release, index) =>
      supabase
        .from('releases')
        .update({ order: index })
        .eq('id', release.id)
    );

    const results = await Promise.all(updatePromises);
    
    // Check for any errors
    const errors = results.filter(result => result.error);
    if (errors.length > 0) {
      throw new Error(`Failed to update ${errors.length} releases`);
    }
  } catch (error) {
    console.error('Error updating release order:', error);
    throw error;
  }
}

export async function deleteRelease(id: string): Promise<void> {
  try {
    const { error } = await supabase
      .from('releases')
      .delete()
      .eq('id', id);

    if (error) throw error;
  } catch (error) {
    console.error('Error deleting release:', error);
    throw error;
  }
}